/**
 * Homepage hero search — VIN / YMM (scoped IDs under [data-home-hero-search]).
 * Tire size uses tire-size-fitment.js on #hero-tire-size.
 */
(function () {
  var root = document.querySelector("[data-home-hero-search]");
  if (!root) return;

  var RESULTS_PAGE = "/pages/tire-results";
  var TRIMS_PROXY = "/apps/specr/api/tire-vin-trims";
  var MAKES_PROXY = "/apps/specr/api/tire-ymm-makes";
  var MODELS_PROXY = "/apps/specr/api/tire-ymm-models";

  var vinInput = root.querySelector("#hero-vin");
  var vinBtn = root.querySelector("#hero-vin-btn");
  var vinError = root.querySelector("#hero-vin-error");
  var yearSel = root.querySelector("#hero-year");
  var makeSel = root.querySelector("#hero-make");
  var modelSel = root.querySelector("#hero-model");
  var trimSel = root.querySelector("#hero-trim");
  var ymmBtn = root.querySelector("#hero-ymm-btn");
  var ymmHint = root.querySelector("#hero-ymm-hint");

  var makeFetchController = null;
  var modelFetchController = null;
  var trimFetchController = null;
  var makeRequestSeq = 0;
  var modelRequestSeq = 0;
  var trimRequestSeq = 0;
  var makeIdByName = {};

  function showEl(el) {
    if (el) el.hidden = false;
  }
  function hideEl(el) {
    if (el) el.hidden = true;
  }

  function setYmmHint(message) {
    if (!ymmHint) return;
    if (!message) {
      hideEl(ymmHint);
      ymmHint.textContent = "";
      return;
    }
    ymmHint.textContent = message;
    showEl(ymmHint);
  }

  function resetTrimSelect() {
    if (!trimSel) return;
    trimSel.innerHTML = '<option value="">Trim</option>';
    trimSel.disabled = true;
  }

  function resetModelSelect() {
    if (!modelSel) return;
    modelSel.innerHTML = '<option value="">Model</option>';
    modelSel.disabled = true;
    resetTrimSelect();
    updateYmmSearchButton();
  }

  function resetMakeAndModel() {
    if (!makeSel) return;
    makeSel.innerHTML = '<option value="">Make</option>';
    makeSel.disabled = true;
    makeIdByName = {};
    resetModelSelect();
  }

  function updateYmmSearchButton() {
    if (ymmBtn) ymmBtn.disabled = !yearSel || !yearSel.value || !makeSel.value || !modelSel.value;
  }

  function buildSearchSummary(qs) {
    if (window.SpecrTireWizard && window.SpecrTireWizard.summaryFromQuery) {
      return window.SpecrTireWizard.summaryFromQuery(qs);
    }
    return "Your search";
  }

  function goToResults(queryString) {
    if (yearSel && makeSel && modelSel && yearSel.value && makeSel.value && modelSel.value) {
      try {
        localStorage.setItem(
          "specr_vehicle_ymm",
          JSON.stringify({
            year: yearSel.value,
            make: makeSel.value,
            model: modelSel.value,
          })
        );
      } catch (e) {}
    }
    var qs = queryString || "";
    if (window.SpecrTireWizard && window.SpecrTireWizard.open) {
      window.SpecrTireWizard.open({
        searchQuery: qs.indexOf("?") === 0 ? qs : qs ? "?" + qs.replace(/^\?/, "") : "",
        summary: buildSearchSummary(qs),
      });
      return;
    }
    if (window.SpecrTireProfile) {
      qs = window.SpecrTireProfile.appendProfileToQueryString(qs);
    }
    window.location.href = RESULTS_PAGE + (qs.indexOf("?") === 0 ? qs : qs ? "?" + qs.replace(/^\?/, "") : "");
  }

  function loadTrimsForModel() {
    if (!trimSel) return;
    resetTrimSelect();
    var selectedYear = yearSel.value;
    var selectedMake = makeSel.value;
    var selectedModel = modelSel.value;
    if (!selectedYear || !selectedMake || !selectedModel) return;

    trimSel.innerHTML = '<option value="">Loading trims…</option>';
    trimSel.disabled = true;

    if (trimFetchController) trimFetchController.abort();
    var requestSeq = ++trimRequestSeq;
    trimFetchController = typeof AbortController !== "undefined" ? new AbortController() : null;

    var trimUrl =
      TRIMS_PROXY +
      "?year=" +
      encodeURIComponent(selectedYear) +
      "&make=" +
      encodeURIComponent(selectedMake) +
      "&model=" +
      encodeURIComponent(selectedModel);

    fetch(trimUrl, trimFetchController ? { signal: trimFetchController.signal } : undefined)
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        if (requestSeq !== trimRequestSeq) return;
        if (
          yearSel.value !== selectedYear ||
          makeSel.value !== selectedMake ||
          modelSel.value !== selectedModel
        ) {
          return;
        }
        if (d.error) {
          resetTrimSelect();
          return;
        }
        if (window.SpecrTireTrimSelect && window.SpecrTireTrimSelect.populate) {
          window.SpecrTireTrimSelect.populate(trimSel, d);
        }
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        if (requestSeq !== trimRequestSeq) return;
        resetTrimSelect();
      });
  }

  function initYears() {
    if (!yearSel) return;
    var currentYear = new Date().getFullYear() + 1;
    for (var y = currentYear; y >= 1995; y--) {
      var opt = document.createElement("option");
      opt.value = String(y);
      opt.textContent = String(y);
      yearSel.appendChild(opt);
    }
    yearSel.addEventListener("change", function () {
      setYmmHint("");
      makeSel.innerHTML = '<option value="">Loading…</option>';
      makeSel.disabled = true;
      resetModelSelect();
      if (makeFetchController) makeFetchController.abort();
      if (modelFetchController) modelFetchController.abort();
      if (trimFetchController) trimFetchController.abort();
      if (!yearSel.value) {
        resetMakeAndModel();
        return;
      }
      var selectedYear = yearSel.value;
      var requestSeq = ++makeRequestSeq;
      makeFetchController = typeof AbortController !== "undefined" ? new AbortController() : null;
      fetch(MAKES_PROXY, makeFetchController ? { signal: makeFetchController.signal } : undefined)
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          if (requestSeq !== makeRequestSeq || yearSel.value !== selectedYear) return;
          if (d.error) {
            resetMakeAndModel();
            setYmmHint("Could not load makes. Try again or search by tire size.");
            return;
          }
          makeIdByName = d.makeIdByName || {};
          makeSel.innerHTML = '<option value="">Make</option>';
          (d.curated || []).forEach(function (name) {
            var opt = document.createElement("option");
            opt.value = name;
            opt.textContent = name;
            makeSel.appendChild(opt);
          });
          if ((d.other || []).length) {
            var group = document.createElement("optgroup");
            group.label = "More makes";
            d.other.forEach(function (name) {
              var opt = document.createElement("option");
              opt.value = name;
              opt.textContent = name;
              group.appendChild(opt);
            });
            makeSel.appendChild(group);
          }
          makeSel.disabled = false;
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          if (requestSeq !== makeRequestSeq || yearSel.value !== selectedYear) return;
          resetMakeAndModel();
          setYmmHint("Could not load makes. Try again or search by tire size.");
        });
    });

    makeSel.addEventListener("change", function () {
      setYmmHint("");
      resetModelSelect();
      if (modelFetchController) modelFetchController.abort();
      var selectedYear = yearSel.value;
      var selectedMake = makeSel.value;
      if (!selectedYear || !selectedMake) return;
      modelSel.innerHTML = '<option value="">Loading…</option>';
      var requestSeq = ++modelRequestSeq;
      modelFetchController = typeof AbortController !== "undefined" ? new AbortController() : null;
      var makeId = makeIdByName[(selectedMake || "").toUpperCase()] || "";
      var modelUrl =
        MODELS_PROXY +
        "?year=" +
        encodeURIComponent(selectedYear) +
        "&make=" +
        encodeURIComponent(selectedMake) +
        (makeId ? "&makeId=" + encodeURIComponent(makeId) : "");
      fetch(modelUrl, modelFetchController ? { signal: modelFetchController.signal } : undefined)
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          if (requestSeq !== modelRequestSeq || yearSel.value !== selectedYear || makeSel.value !== selectedMake)
            return;
          if (d.error) {
            resetModelSelect();
            setYmmHint("Could not load models for this make. Try another make or search by size.");
            return;
          }
          var models = d.models || [];
          modelSel.innerHTML = '<option value="">Model</option>';
          models.forEach(function (name) {
            var opt = document.createElement("option");
            opt.value = name;
            opt.textContent = name;
            modelSel.appendChild(opt);
          });
          modelSel.disabled = models.length === 0;
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          if (requestSeq !== modelRequestSeq || yearSel.value !== selectedYear || makeSel.value !== selectedMake)
            return;
          resetModelSelect();
          setYmmHint("Could not load models. Check your connection or search by tire size.");
        });
    });

    modelSel.addEventListener("change", function () {
      updateYmmSearchButton();
      if (modelSel.value) loadTrimsForModel();
      else resetTrimSelect();
    });
    if (trimSel) {
      trimSel.addEventListener("change", updateYmmSearchButton);
    }
  }

  function initVin() {
    if (!vinBtn || !vinInput) return;
    vinBtn.addEventListener("click", function () {
      var vin = (vinInput.value || "").replace(/[^A-HJ-NPR-Z0-9]/gi, "").toUpperCase();
      if (vinError) {
        vinError.hidden = true;
        vinError.textContent = "";
      }
      if (vin.length !== 17) {
        if (vinError) {
          vinError.textContent = "VIN must be exactly 17 characters.";
          vinError.hidden = false;
        }
        return;
      }
      goToResults("?vin=" + encodeURIComponent(vin));
    });
    vinInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        vinBtn.click();
      }
    });
  }

  function initYmmButton() {
    if (!ymmBtn) return;
    ymmBtn.addEventListener("click", function () {
      var q =
        "?year=" +
        encodeURIComponent(yearSel.value) +
        "&make=" +
        encodeURIComponent(makeSel.value) +
        "&model=" +
        encodeURIComponent(modelSel.value);
      if (trimSel && trimSel.value) q += "&trim=" + encodeURIComponent(trimSel.value);
      goToResults(q);
    });
  }

  function initTabs() {
    var tabs = root.querySelectorAll("[data-hero-tab]");
    var panels = root.querySelectorAll("[data-hero-panel]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var id = tab.getAttribute("data-hero-tab");
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute("data-hero-panel") !== id;
        });
      });
    });
  }

  function initSavedVehicles() {
    var wrap = root.querySelector("#hero-my-vehicles");
    var list = root.querySelector("#hero-vehicles-list");
    var custId = root.getAttribute("data-customer-id");
    if (!wrap || !list || !custId) return;

    fetch("/apps/specr/api/vehicles?logged_in_customer_id=" + encodeURIComponent(custId))
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        var vehicles = d.vehicles || d.customerVehicles || [];
        if (!vehicles.length) return;
        wrap.hidden = false;
        vehicles.forEach(function (v) {
          var label = [v.year, v.make, v.model].filter(Boolean).join(" ") || "Vehicle";
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "home-hero-search__chip";
          btn.textContent = label;
          btn.addEventListener("click", function () {
            if (v.vin) goToResults("?vin=" + encodeURIComponent(v.vin));
            else if (v.id) goToResults("?vehicleId=" + encodeURIComponent(v.id));
            else if (v.year && v.make && v.model) {
              goToResults(
                "?year=" +
                  encodeURIComponent(v.year) +
                  "&make=" +
                  encodeURIComponent(v.make) +
                  "&model=" +
                  encodeURIComponent(v.model)
              );
            }
          });
          list.appendChild(btn);
        });
      })
      .catch(function () {});
  }

  initTabs();
  initYears();
  initVin();
  initYmmButton();
  initSavedVehicles();
})();
